/**
 * A/B Experiment Configuration
 *
 * Define all experiments here. Each experiment needs:
 * - id: Unique identifier (used in cookies and tracking)
 * - variants: Array of variant names (first is always 'control')
 * - weights: Optional array of weights (must sum to 1, defaults to equal distribution)
 * - active: Whether the experiment is currently running
 *
 * Example usage in components:
 *   const variant = useExperiment('homepage-headline')
 *   {variant === 'control' && <h1>Escape Your Echo Chamber</h1>}
 *   {variant === 'v1' && <h1>See Both Sides in 5 Minutes</h1>}
 */

export const experiments = {
  // No experiments currently running.
  // Example:
  // 'homepage-headline': {
  //   id: 'homepage-headline',
  //   variants: ['control', 'v1'],
  //   weights: [0.5, 0.5],
  //   active: true,
  // },
}

/**
 * Get all active experiments
 */
export function getActiveExperiments() {
  return Object.values(experiments).filter((exp) => exp.active)
}

/**
 * Assign a variant based on weights
 */
export function assignVariant(experiment) {
  const weights = experiment.weights || experiment.variants.map(() => 1 / experiment.variants.length)
  const random = Math.random()
  let cumulative = 0

  for (let i = 0; i < weights.length; i++) {
    cumulative += weights[i]
    if (random < cumulative) {
      return experiment.variants[i]
    }
  }

  return experiment.variants[0] // Fallback to control
}

/**
 * Cookie name for an experiment
 */
export function getExperimentCookieName(experimentId) {
  return `exp_${experimentId}`
}
